import PropTypes from 'prop-types';
import React from 'react';
import css from '../CreateBudget.module.css';
import StepLink from './StepLink';
import ProgressBar from '../../../components/ProgressBar/ProgressBar';

const StepNav = ({ currentStep, step }) => (
  <nav className={css.nav}>
    <StepLink
      label="Select a Client"
      number="01"
      toBase="/create-budget/client"
      active={currentStep >= 1}
    />
    <StepLink
      label="Set Budget"
      number="02"
      toBase="/create-budget/budget"
      active={currentStep >= 2}
    />
    <StepLink
      label="Select Campaigns"
      number="03"
      toBase="/create-budget/campaigns"
      active={step === 'campaigns' && currentStep >= 3}
    />
    <ProgressBar step={currentStep} />
  </nav>
);

StepNav.propTypes = {
  currentStep: PropTypes.number.isRequired,
  step: PropTypes.string.isRequired,
};

export default StepNav;
